import { Table } from "@/features/Table";
import { type G4DynamicDatum, g4_dynamic_data_columns } from "./columns";
import { type FilterG4DynamicDataSchema, FilterG4DynamicData } from "./filter";

const client = "g4";
const table_name = "g4_dynamic_data";

export const G4DynamicDataTable = () => {
  return (
    <Table<G4DynamicDatum, FilterG4DynamicDataSchema>
      label="G4 Dynamic Data"
      client={client}
      table_name={table_name}
      columns={g4_dynamic_data_columns}
      filter={<FilterG4DynamicData />}
      actions={[
        {
          label: "actions.new",
          route: `${client}/${table_name}/new`,
        },
      ]}
    />
  );
};
